<div [hidden]="showLogin" class="container-login">
  <div class="columns center">
    <div *ngIf="optSelected == 1" class="column is-4-desktop is-6-tablet">

      <!-- FORMULARIO PARA LOGIN -->
      <div class="card-login">
        <img (click)="closeLogin()" src="/assets/icons/close.svg" alt="" class="icon-close">
        <div class="container-wellcome">
          <span class="title">¡Bienvenido!</span>
          <span class="subtitle margin-top-05">Ahora los espacios de tu ciudad cobran vida y abren sus puertas para ti...        </span>
        </div>

        <div class="container-form">
          <div class="container-input-indicative">
            <div class="container-indicative">
              <span (click)="showIndicatives()" class="indicative-selected"> {{ '(+' + indicativeSelected + ')' }} </span>
              <div [ngClass]="{'show': statusSelectIndicative}" class="list-indicatives">
                <div
                  *ngFor="let indicative of listIndicatives"
                  class="item-indicative"
                  (click)="selectIndicative(indicative.code)" >
                  <span class="indicative-code" > {{ '(+' + indicative.code + ')' }} </span>
                  <span class="indicative-name" > - {{ indicative.name }}</span>
                </div>
              </div>
            </div>
            <img src="/assets/icons/arrow.svg" alt="" class="icon-arrow">
            <input
              placeholder="Número de teléfono"
              class="input-tel"
              type="tel"
              [(ngModel)]="numberPhone"
              (keyup)="validateOnlyNumbers()"
              >
          </div>
          <!-- <span (click)="selectOpt(2)" class="no-has-account margin-top-10">¿No tienes cuenta?</span> -->
        </div>
        <div *ngIf="!loading" class="width_full center">
          <a *ngIf="!phoneValid" class="btn disabled center" >Iniciar sesión</a>
          <a *ngIf="phoneValid" (click)="getCode()" class="btn abled center" >Iniciar sesión</a>  
        </div>
        <div *ngIf="loading" class="width_full center">
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
        <span class="termins"> <a target="_blank" href="http://siteit.co/tyc.html"> Al hacer click aceptas los <strong class="bold" >terminos y condiciones</strong> </a> </span>
      </div>

    </div>
    
    <div *ngIf="optSelected == 2" class="column is-4-desktop is-6-tablet">

      <!-- FORMULARIO PARA REGISTRO -->
      <div class="card-login">
        <img (click)="closeLogin()" src="/assets/icons/close.svg" alt="" class="icon-close">
        <div class="container-wellcome">
          <span class="title">¡Bienvenido!</span>
          <span class="subtitle margin-top-05">Ahora los espacios de tu ciudad cobran vida y abren sus puertas para ti...        </span>
        </div>
        <div class="container-form">
          <div class="container-input-indicative">
            <input
              placeholder="Nombre y apellido"
              class="input-tel"
              type="text"
              [(ngModel)]="userName"
              >
          </div>
          <!-- <span class="no-has-account margin-top-10">¿No tienes cuenta?</span> -->
        </div>
        <div class="width_full center">
          <a (click)="registerUser()" class="btn abled center" >Registrarme</a>
        </div>
        <span class="termins"> <a target="_blank" href="http://siteit.co/tyc.html"> Al hacer click aceptas los <strong class="bold" >terminos y condiciones</strong> </a> </span>
      </div>

    </div>


    <div *ngIf="optSelected == 3" class="column is-4-desktop is-6-tablet">

     
      <!-- FORMULARIO PARA CÓDIGO -->
      <div class="card-login">
        <img (click)="closeLogin()" src="/assets/icons/close.svg" alt="" class="icon-close">
        <div class="container-wellcome">
          <span class="title">Autenticación</span>
          <span class="subtitle margin-top-05">Te hemos enviado un código por WhatsApp, digitalo a continuación:</span>
        </div>
  
        <div class="container-code">
          <input id="code1" (keyup)="keyUp('code2')" (click)="code1 = ''" [(ngModel)]="code1" class="input-code" type="text" autocomplete="off" autofocus="true" >
          <input id="code2" (keyup)="keyUp('code3')" (click)="code2 = ''" [(ngModel)]="code2" class="input-code" type="text" autocomplete="off" >
          <input id="code3" (keyup)="keyUp('code4')" (click)="code3 = ''" [(ngModel)]="code3" class="input-code" type="text" autocomplete="off" >
          <input id="code4" (keyup)="keyUp('code5')" (click)="code4 = ''" [(ngModel)]="code4" class="input-code" type="text" autocomplete="off" >
          <input id="code5" (keyup)="keyUp()"        (click)="code5 = ''" [(ngModel)]="code5" class="input-code" type="text" autocomplete="off" >
        </div>

        <div class="width_full center">
          <a *ngIf="codeValid == 1" class="btn disabled center" > Ingresar código </a>
          <a *ngIf="codeValid == 2" (click)="login()"    class="btn abled center" >Ingresar código</a> 
          <a *ngIf="codeValid == 3"  class="btn abled center" >Ingresando...</a>
        </div>
        <div class="width_full center">
          <a    *ngIf="resendCode == 0" class="btn abled center" (click)="getCode()" > Reenviar código </a>
          <span *ngIf="resendCode != 0" class="countdown" > Reenviar mi código: 00: {{ resendCode }} </span>
        </div>
        <span class="termins">Al hacer click aceptas los <strong class="bold" >terminos y condiciones</strong> </span>
      </div>


      
    </div>

  </div>

</div>